const prefix = '@gifts';

export const FETCH_GIFTS_REQUEST = `${prefix}/FETCH_GIFTS_REQUEST`;
export const FETCH_GIFTS_SUCCESS = `${prefix}/FETCH_GIFTS_SUCCESS`;
export const FETCH_GIFTS_FAILURE = `${prefix}/FETCH_GIFTS_FAILURE`;
